import { render, staticRenderFns } from "./TopBarNav.vue?vue&type=template&id=af653442&"
import script from "./TopBarNav.vue?vue&type=script&lang=js&"
export * from "./TopBarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports